// extracted by mini-css-extract-plugin
module.exports = {"link":"ItemTypesManagement_link__H8p8P"};